import { useState } from 'react'

import { JSON_SPACE } from 'constants/json'
import { AuditLog } from 'features/history/types/auditLog'
import { AuditLogDTO } from 'features/history/types/auditLogDTO'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_AUDIT_LOGS } from './api/query'
import { Data, Variables } from './api/types'

import type { UseGetAuditLogs, UseGetAuditLogsProps } from './types'

export const useGetAuditLogs = ({ first, last }: UseGetAuditLogsProps): UseGetAuditLogs => {
  const [data, setData] = useState<string>()
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        auditLogs: { nodes, totalCount },
      } = data

      if (nodes && nodes.length > 0) {
        const auditLogs: AuditLog[] = nodes.map((log: AuditLogDTO): AuditLog => fromDTO(log))
        const stringifiedLogs = JSON.stringify(auditLogs, null, JSON_SPACE)

        setData(stringifiedLogs)
      }

      setCount(totalCount)
    },
    query: GET_AUDIT_LOGS,
    variables: { first, last },
  })

  return {
    auditLogs: data,
    count,
    loading,
  }
}
